<div class="infogrid">
  <div style="grid-column-start: 1; grid-column-end: 3">
    <p class="text--small" style="padding-left: 15px">{{ contract().contractNumber }} | {{ contract().description }}</p>
  </div>
  @for (item of contract().items; track item) {
    <div class="text--small contract-item" style="padding-left: 15px">
      <span class="text--bold">{{ item.description }}</span> <br />
      <span class="text--small">{{ item.dueDate | date: 'd.M.yyyy' }}</span>
    </div>
    <div style="align-content: flex-end; padding-right: 15px" [class.contract]="!$last">
      <p class="rightAlignTop text--small item-amount">{{ item.amountInEuro | currency: 'EUR' : 'code' : '1.2-2' }}</p>
    </div>
  }
</div>
